import React, { useState } from 'react';
import { API_URL } from '../../constants/api';
import { decodeFullToken, getToken } from '../../utils/TokenUtils';

export default function AppIntro() {
  const [category, setCategory] = useState('shop');
  const [title, setTitle] = useState('KAAFIPAY');
  const [serial, setSerial] = useState('01');
  const [showInputs, setShowInputs] = useState(true);

  const serialText = `${category.toUpperCase()}-${serial}`;
  const token = getToken();
  const decoded = decodeFullToken(token);

  if (!decoded) return <div>Loading...</div>;

  const phoneStyle = {
    width: 390,
    height: 844,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 36,
    boxShadow: '0 15px 50px rgba(0,0,0,0.5)',
    // backgroundImage: decoded?.backgroundImage
    //   ? `url(${API_URL}/${decoded.backgroundImage})`
    //   : 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <div style={styles.page}>
      {/* Eye toggle */}

      {/* Form */}
      {showInputs && (
        <div style={styles.form}>
          <h2 style={{ textAlign: 'center' }}>Reel Screen Inputs</h2>

          <label>Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            style={styles.input}
          >
            <option value="shop">Shop</option>
            <option value="service">Service</option>
            <option value="production">Production</option>
            <option value="restaurant">Restaurant</option>
            <option value="taxfiid">Taxfiid</option>
          </select>

          <label>Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={styles.input}
          />

          <label>Serial</label>
          <input
            value={serial}
            onChange={(e) => setSerial(e.target.value)}
            style={styles.input}
          />
        </div>
      )}

      {/* Phone preview */}
      <div style={phoneStyle}>
        {/* Overlay for gradient */}
        <div style={styles.overlay}></div>

        {/* Content */}
        <div style={styles.content}>
          <div style={styles.topBar}>
            <div style={styles.serial}>
              KAAFIPAY: {serialText}
              <button
                style={styles.eyeButton}
                onClick={() => setShowInputs(!showInputs)}
              >
                {showInputs ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div style={styles.center}>
            <div style={styles.logo}>
              <img
                src={`${API_URL}/${decoded?.logo}`}
                alt="logo"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>

            <div style={styles.appName}>{title}</div>
            <div style={styles.tagline}>
              {serialText} - Diiwaangelinta Ganacsiga
            </div>

            {/* Overlay inputs */}
            {showInputs && (
              <div style={styles.overlayInputs}>
                <div>Category: {category.toUpperCase()}</div>
                <div>Title: {title}</div>
                <div>Serial: {serialText}</div>
              </div>
            )}
          </div>

          {/* Contact Info */}
          <div style={styles.contactCard}>
            <h4 style={styles.contactHeader}>Contact Information</h4>
            <div style={styles.contactItem}>📞 +254 769 624 455</div>
            <div style={styles.contactItem}>✉️ info@kaafipay.so</div>
            <div style={styles.contactItem}>🌐 www.kaafipay.so</div>
            <div style={styles.contactItem}>📍 Nairobi, Kenya</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Rewritten modern styles
const styles = {
  page: {
    display: 'flex',
    gap: 40,
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    // background: '#0c0c0c',
    fontFamily: 'Arial, sans-serif',
    padding: 20,
    color: '#fff',
  },

  eyeButton: {
    borderRadius: 10,
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#fff',
    transition: '0.2s',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    background: '#111827',
    padding: 20,
    borderRadius: 16,
    width: 260,
    boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
  },

  input: {
    padding: 10,
    borderRadius: 8,
    border: 'none',
    fontSize: 14,
  },

  overlay: {
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.25), rgba(0,0,0,0.55), rgba(0,0,0,0.75))',
    zIndex: 1,
  },

  content: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 24,
  },

  topBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  serial: {
    fontSize: 14,
    fontWeight: 'bold',
    background: 'rgba(3, 45, 255, 0.6)',
    padding: '8px 16px',
    borderRadius: 24,
    letterSpacing: 0.5,
  },

  center: {
    textAlign: 'center',
  },

  logo: {
    width: 180,
    height: 180,
    margin: '0 auto 18px auto',
    borderRadius: 16,
    padding: 10,
    background: 'rgba(255,255,255,0.1)',
  },

  appName: {
    fontSize: 32,
    fontWeight: 800,
    marginBottom: 8,
  },

  tagline: {
    fontSize: 22,
    lineHeight: 1.4,
    opacity: 0.9,
  },

  overlayInputs: {
    marginTop: 18,
    background: 'rgba(0,0,0,0.55)',
    borderRadius: 12,
    padding: 12,
    fontSize: 15,
    fontWeight: 600,
  },

  contactCard: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: 24,
    padding: 20,
    textAlign: 'center',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
  },

  contactHeader: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 12,
    letterSpacing: 0.5,
  },

  contactItem: {
    fontSize: 14,
    lineHeight: 1.8,
    marginBottom: 4,
  },
};
